module.exports = __webpack_public_path__ + "static/media/Bluelab Pulse Multimedia.ee47212e.webp";